import { useEffect } from "react";

export function WidgetModal({ isOpen, onClose, title, children, size = "lg" }) {
    // Bloquear scroll del body cuando el modal está abierto
    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [isOpen]);

    if (!isOpen) return null;

    const maxWidthClass =
        size === "xl" ? "max-w-6xl" :
        size === "lg" ? "max-w-4xl" :
        size === "sm" ? "max-w-md"  : "max-w-2xl";

    return (
        <div
            className="fixed inset-0 z-50 flex items-start justify-center p-4 pt-10 overflow-y-auto"
            aria-modal="true"
            role="dialog"
            aria-labelledby="widget-modal-title"
        >
            {/* Overlay */}
            <div
                className="fixed inset-0 bg-black/50 backdrop-blur-sm"
                onClick={onClose}
            />

            {/* Panel */}
            <div className={`relative z-10 w-full ${maxWidthClass} flex flex-col rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-2xl overflow-hidden mb-10`}>

                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 bg-blue-600 dark:bg-blue-700 flex-shrink-0">
                    <h5
                        id="widget-modal-title"
                        className="text-base font-semibold text-white flex items-center gap-2"
                    >
                        <i className="fas fa-edit"></i>
                        {title}
                    </h5>
                    <button
                        type="button"
                        onClick={onClose}
                        className="text-white/80 hover:text-white transition-colors p-1 rounded"
                        aria-label="Cerrar"
                    >
                        <i className="fas fa-times text-lg"></i>
                    </button>
                </div>

                {/* Body */}
                <div className="flex-1 overflow-y-auto bg-white dark:bg-gray-800">
                    {children}
                </div>

                {/* Footer */}
                <div className="flex justify-end px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 flex-shrink-0">
                    <button
                        id="close-modal"
                        type="button"
                        onClick={onClose}
                        className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm font-medium px-4 py-2 transition-colors"
                    >
                        <i className="fas fa-times"></i>
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
}
